export const RIDE_ITEM_TEXT = {
	rideIdLabel: 'Ride ID:',
	vehiclesLabel: 'Vehicle(s):',
	naJob: 'Job: N/A',
	naRun: 'N/A',
	/** @param {string} code */
	linePrefix: (code) => `LN ${code}`,
	/** @param {string} number */
	tripPrefix: (number) => `TN ${number}`,
	/**
	 * @param {string} runName
	 * @param {number} extraRuns
	 */
	runLabel: (runName) => `Run: ${runName}`,
	/** @param {string[]} codes */
	jobLabel: (codes) => `Job: ${codes.join(',')}`,
	/**
	 * @param {string} fromCode
	 * @param {string} fromName
	 * @param {string} toCode
	 * @param {string} toName
	 */
	route: (fromCode, fromName, toCode, toName) =>
		`${fromCode} (${fromName}) → ${toCode} (${toName})`,
	/**
	 * @param {string} time Already formatted.
	 * @param {string} timezone
	 */
	departure: (time, timezone) => `Departure: ${time} (${timezone})`,
	/** @param {number} extra */
	extraRuns: (extra) => `+${extra}`,
};
